export default {"src":"/_next/static/media/cruise.8dedc964.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};